import {
  GET_DEAL_LIST_DATA, DELETE_DEAL_LIST, SAVE_DEAL_LIST_DATA, SAVE_DEAL_STATUS_LIST, SAVE_DEAL_LIST_FILE,
  SHARE_DEAL_DATA, UPDATE_FILE_DEAL_LIST, RESET_DEAL_STATUS_CHANGE_LIST_DATA, GET_DEAL_STATUS_CHANGE_LIST_DATA,
} from '../../constants/system/actions';

const getDealListData: Function = (payload?: ActionPayload, resolve?: Function, reject?: Function): ReduxAction => ({
  type: GET_DEAL_LIST_DATA, payload, resolve, reject,
});

const getDealStatusChangeListData: Function = (
  payload?: ActionPayload, resolve?: Function, reject?: Function,
): ReduxAction => ({
  type: GET_DEAL_STATUS_CHANGE_LIST_DATA, payload, resolve, reject,
});

const deleteDealList: Function = (payload?: ActionPayload, resolve?: Function, reject?: Function): ReduxAction => ({
  type: DELETE_DEAL_LIST, payload, resolve, reject,
});

const shareDealData: Function = (payload?: ActionPayload, resolve?: Function, reject?: Function): ReduxAction => ({
  type: SHARE_DEAL_DATA, payload, resolve, reject,
});

const updateFileDealList: Function = (payload?: ActionPayload, resolve?: Function, reject?: Function): ReduxAction => ({
  type: UPDATE_FILE_DEAL_LIST, payload, resolve, reject,
});

const saveDealListData: Function = (payload?: ActionPayload, resolve?: Function, reject?: Function): ReduxAction => ({
  type: SAVE_DEAL_LIST_DATA, payload, resolve, reject,
});

const saveDealStatusList: Function = (payload?: ActionPayload, resolve?: Function, reject?: Function): ReduxAction => ({
  type: SAVE_DEAL_STATUS_LIST, payload, resolve, reject,
});

const saveDealListFile: Function = (payload?: ActionPayload, resolve?: Function, reject?: Function): ReduxAction => ({
  type: SAVE_DEAL_LIST_FILE, payload, resolve, reject,
});

const resetDealStatusChangeListData: Function = (payload?: ActionPayload): ReduxAction => ({
  type: RESET_DEAL_STATUS_CHANGE_LIST_DATA, payload,
});

export {
  getDealListData,
  getDealStatusChangeListData,
  deleteDealList,
  shareDealData,
  updateFileDealList,
  saveDealListData,
  saveDealStatusList,
  saveDealListFile,
  resetDealStatusChangeListData,
};
